import { render, staticRenderFns } from "./accepted-forms.vue?vue&type=template&id=200bd5a6&"
import script from "./accepted-forms.vue?vue&type=script&lang=js&"
export * from "./accepted-forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports